import React from "react";
import Marquee from "react-fast-marquee";

const PHRASES = [
  "MDPE PIPELINES",
  "STEEL GRIDS",
  "PNG CONNECTIONS",
  "HDD CROSSINGS",
  "COMMISSIONING",
  "UTILITY CORRIDORS",
  "OFC NETWORKS",
  "PRESSURE TESTING",
];

export const EditorialMarquee = () => {
  return (
    <div className="bg-brand-orange overflow-hidden py-4 border-y border-orange-700/30" data-testid="editorial-marquee">
      <Marquee speed={18} gradient={false} pauseOnHover>
        {PHRASES.concat(PHRASES).map((p, i) => (
          <span key={i} className="flex items-center">
            <span className="font-mono-tech text-xs md:text-sm tracking-[0.3em] text-white font-medium px-6 md:px-10">
              {p}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-white/60" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
